module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.60cbef3.woff2";